import { Show, type Component } from "solid-js";
import { PanelLayout } from "@/shared/panel-base";
import { PanelPreview } from "@/shared/panel-primitives";
import { usePanel } from "@/shared/use-panel";
import { useWs } from "@/shared/ws";
import { registerPanel } from "@/panel-registry";

const RdpSessionsPanel: Component = () => {
  const ws = useWs();
  const enabled = () => ws.state.agentFeatures?.rdpsessions === true;
  const panel = usePanel(() => ({ isFetching: false, error: null }));

  return (
    <PanelLayout title="Sessions utilisateurs (RDP / console)" status={panel.status()}>
      <Show
        when={enabled()}
        fallback={
          <PanelPreview
            feature="rdpsessions"
            goal="Voir qui est connecté à l'hôte (RDP et console) et pouvoir déconnecter / envoyer un message. Distinct du panel RDP qui ouvre une session SORTANTE."
            tools={[
              {
                name: "rdpsessions_list",
                description:
                  "Sessions en cours : sessionId, username, état (Active/Disconnected/Idle), depuis, IP client, type (console/rdp)",
              },
              {
                name: "rdpsessions_processes",
                description: "Processus appartenant à une sessionId (qsession + tasklist /fi)",
              },
              {
                name: "rdpsessions_disconnect",
                description:
                  "Déconnecter une session (l'utilisateur peut se reconnecter) — destructif léger, requiert userConfirmedAt",
              },
              {
                name: "rdpsessions_logoff",
                description:
                  "Forcer le logoff (l'utilisateur perd son travail non sauvegardé) — destructif fort, requiert userConfirmedAt",
              },
              { name: "rdpsessions_message", description: "Envoyer un message MessageBox à une session (msg /server)" },
              {
                name: "rdpsessions_shadow",
                description: "Initier une session shadow / observe (optionnel — Pro/Server seulement)",
              },
            ]}
            notes="Backend agent : query session / quser / msg. Sur Pro/Workstation Windows, RDS Shadow n'est pas dispo — gracefully indiquer non supporté. Le panel doit refresh auto (5 s) car les sessions changent souvent."
          />
        }
      >
        <div style={{ padding: "12px" }}>Implémentation en cours…</div>
      </Show>
    </PanelLayout>
  );
};

registerPanel("rdpsessions", RdpSessionsPanel);
export default RdpSessionsPanel;
